


















































import { Component, Vue } from 'vue-property-decorator';
import { vpnService } from '@/services/VpnService';
import * as FileSaver from 'file-saver';

@Component({})
export default class vpnClientDownload extends Vue {
  password = '';
  vpnUserUuid = '';
  vpnData: any = {};
  isError: boolean = false;
  isActivePassValidation = false;
  wrongPass = false;
  isLoading = false;

  mounted() {
    this.vpnUserUuid = this.$route.params.vpnUserUuid;
    this.getData();
  }
  getData() {
    vpnService
      .getVpnClientData(this.vpnUserUuid)
      .then((data: any) => {
        this.vpnData = data;
      })
      .catch((data: any) => {
        if (data.status === 404) {
          this.isError = true;
        }
      });
  }
  downloadVpnClient(os: string) {
    this.isActivePassValidation = true;
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    vpnService
      .downloadVpnClient(this.vpnUserUuid, this.password, os, true)
      .then(response => {
        let filename: any = response.headers['content-disposition'].match(/filename="([^"]+)"/i);
        filename = !!filename && filename[1] ? filename[1] : 'unknown.bin';
        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        FileSaver.saveAs(blob, filename);
        this.isLoading = false;
      })
      .catch((data: any) => {
        if (data && data.data && data.status === 401) {
          if (data.data.errors === 'unauthorized') {
            this.wrongPass = true;
          }
        }
        if (data && data.data && data.status === 404) {
          this.isError = true;
        }
        this.isLoading = false;
      });
  }
}
